import { AbstractModel } from '@patsnap/tahiti-core';
import { NoveltyCheckTaskStatusModel } from '../novelty-check-task-status-model';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { TaskStatus } from '@/domains/task/enums';
import { NoveltyCheckTaskStep } from '../../enums';
import type { NoveltyCheckTaskStatus } from '../../types';

function createInitialNoveltyCheckTaskStatus(): NoveltyCheckTaskStatus {
    return {
        taskStatus: TaskStatus.READY,
        taskStep: NoveltyCheckTaskStep.INITIAL,
        lastUpdateTime: '',
        userInput: '',
        inputLanguage: '',
    };
}

@injectable()
export class NoveltyCheckTaskStatusModelImpl extends AbstractModel<NoveltyCheckTaskStatus> implements NoveltyCheckTaskStatusModel {
    protected _modelData: NoveltyCheckTaskStatus = createInitialNoveltyCheckTaskStatus();

    dispose(): void {
        this.update(() => createInitialNoveltyCheckTaskStatus());
    }
}
